import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGift, faMapMarkerAlt, faCity, faStar, faGlobe, faBook, faBookOpen, faDownload, faGifts, faHandsHelping, faPhone, faRainbow, faShoppingCart, faStore, faVideo, faQrcode } from '@fortawesome/free-solid-svg-icons';
import './NoSecrets.css';
import nosecretsimage from '../../assets/pageimages/NothingSecret.webp';

function NoSecretsHome() {

  return (
    <MainLayout>
      <div className="min-h-full py-8 bg-gradient-to-r from-gray-600 via-gray-700 to-gray-800 mt-12">
        <h2 className='text-3xl font-bold text-white text-center mb-2'>NothingSecret</h2>
        <div className="min-h-[50vh] px-4">
          <div className="flex justify-center mb-6">
            <img src={nosecretsimage} alt="NoSecrets Analysis" style={{width:'300px', height: 'auto'}}className="w-full h-auto max-w-xs md:max-w-sm lg:max-w-md xl:max-w-lg rounded-lg shadow-md" />
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            <Link to="/nosecrets-mychronicles" className="top-button-link"><FontAwesomeIcon icon={faQrcode} className="nosecrets-bottomlink-style" />My Chronicles</Link>
            <Link to="/nosecrets-message" className="top-button-link"><FontAwesomeIcon icon={faQrcode} className="nosecrets-bottomlink-style" />My Messages</Link>
            <Link to="/nosecrets-mydata" className="top-button-link"><FontAwesomeIcon icon={faQrcode} className="nosecrets-bottomlink-style" />My Data</Link>
          </div>
        </div>
      </div>
    </MainLayout>
  );
}

export default NoSecretsHome;
